import { Form, Input, Select } from 'antd';
import { MasterFormField } from 'features/master/components/master-filter-form';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
const { TextArea } = Input;
export const SupplierInfoFormItems = ({ supplierType,selectedType, setSelectedType }: any) => {

    
  return (
    <FormSectionsSeparator title={""}>
      <Form.Item<MasterFormField>
        label={'Title'}
        name={MasterFormField.Title}
        rules={[
          {
            required: true,
            whitespace: true,
          },
        ]}
      >
        <Input
          placeholder={'Enter a title'}
        />
      </Form.Item>

      <Form.Item
        name="type"
        label="Type"
        rules={[{ required: true, message: "Please select type" }]}
      >
        <Select
          placeholder="Select Type"
          options={supplierType?.res?.commonList.map((item: any) => ({
            label: item.title, // "Sales" / "Purchase"
            value: item.id, // ✅ use title instead of id
          }))}
          value={selectedType} // initial value from edit data
          onChange={(value) => setSelectedType(value)}
        />
      </Form.Item>
      
      <Form.Item<MasterFormField>
        label={'Description'}
        name={MasterFormField.description}
        rules={[
          {
            required: true,
            whitespace: true,
          },
        ]}
      >
        <TextArea/>
      </Form.Item>
    </FormSectionsSeparator>
  );
};
